import React from 'react';
import { McTabBar, McTab } from '@maersk-global/mds-react-wrapper/components-core';

interface QueryCategoriesProps {
    categories: string[];
    categoryCounts: Record<string, number>;
    selectedCategory: string;
    onSelectCategory: (category: string) => void;
}

export const QueryCategories: React.FC<QueryCategoriesProps> = ({
    categories,
    categoryCounts,
    selectedCategory,
    onSelectCategory
}) => {
    return (
        <div style={{ borderBottom: '1px solid var(--mds-color-neutral-weak-decoration)', paddingLeft: '16px', paddingRight: '16px' }}>
            <McTabBar
                currentindex={categories.indexOf(selectedCategory)}
                tabchange={(e: any) => {
                    const newIndex = e.detail;
                    if (newIndex >= 0 && newIndex < categories.length) {
                        onSelectCategory(categories[newIndex]);
                    }
                }}
            >
                {categories.map((category) => (
                    <McTab
                        key={category}
                        slot="tab"
                        label={`${category} (${categoryCounts[category] || 0})`}
                    />
                ))}
            </McTabBar>
        </div>
    );
};
